import { Sidebar } from 'primereact/sidebar';
import { MdClose } from 'react-icons/md';
import NotificationItem from '../notification/NotificationItem';
import EmptyNotification from './EmptyNotification';
import styles from './notification.module.css';
import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/services/axios.service';
import { GenericResponse, ListResponse } from '@/common/common_utils';
import { NotificationResponse } from './NotificationResponse';
import { ENDPOINTS } from '@/constants/endpoints';

type NotificationPanelProps = {
	isOpen: boolean;
	onClose: () => void;
	notifications: NotificationResponse[];
};

const NotificationPanel = ({
	isOpen,
	onClose,
	notifications,
}: NotificationPanelProps) => {
	if (!isOpen) return null;



	return (
		<Sidebar
			visible={isOpen}
			onHide={onClose}
			position="right"
			className={styles.sidebarStyle}
			maskClassName={styles.customMask}
			content={() => (
				<div className={styles.notificationPanel}>
					<div className={styles.notificationHeader}>
						<h3 className={styles.notificationTitle}>
							Notifications
						</h3>
						<button
							type="button"
							onClick={onClose}
							className={styles.notificationCloseBtn}
							aria-label="Close notifications"
						>
							<MdClose
								className="text-onSurfaceVariant"
								size={24}
							/>
						</button>
					</div>

					<div
						className={`${styles.notificationContent} ${notifications.length > 0
							? styles.hasNotifications
							: styles.noNotifications
							}`}
					>
						{notifications.length > 0 ? (
							notifications.map((notification) => (
								<NotificationItem
									key={notification.Id}
									notification={notification}
								/>
							))
						) : (
							<EmptyNotification />
						)}
					</div>
				</div>
			)}
		/>
	);
};

export default NotificationPanel;
